<h2 mat-dialog-title>
  {{
    data.title ? (data.title | translate) : ('COLUMN.ACTIONS.TITLE' | translate)
  }}
  @if (data.resolutionLabel) {
    <span> - {{ data.resolutionLabel }}</span>
  }
</h2>

<div mat-dialog-content class="dialog-content">
  <div class="dialog-toolbar">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>{{ 'PRODUCT.EPP.SETTINGS.SEARCH' | translate }}</mat-label>
      <input
        matInput
        [ngModel]="searchTerm()"
        (ngModelChange)="searchTerm.set($event)"
        [placeholder]="'PRODUCT.EPP.SETTINGS.SEARCHPLACEHOLDER' | translate" />
      @if (searchTerm()) {
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="searchTerm.set('')">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    <div class="selection-summary">
      <span>{{ selectedCount() }} / {{ selectableCount() }}</span>

      <mat-checkbox
        [checked]="allSelected()"
        [indeterminate]="someSelected()"
        (change)="toggleAll($event.checked)">
        {{ 'PRODUCT.COMMON.SELECTALL' | translate }}
      </mat-checkbox>
    </div>
  </div>

  <mat-selection-list (selectionChange)="onSelectionChange($event)">
    @for (entry of visibleEntries(); track entry.parameter) {
      <mat-list-option
        [disabled]="data.fixedColumns.includes(entry.parameter)"
        [value]="entry.parameter"
        [selected]="entry.selected">
        {{ 'METPARA_EPP.' + entry.parameter | translate }}
      </mat-list-option>
    }
  </mat-selection-list>
</div>

<div mat-dialog-actions align="end">
  <button
    mat-flat-button
    class="btn-restore"
    type="button"
    (click)="resetDefaults()">
    <fa-icon [icon]="['far', 'sync']"></fa-icon>
  </button>
  <button mat-flat-button color="warn" type="button" (click)="onCancel()">
    <fa-icon [icon]="['far', 'times']"></fa-icon>
    {{ 'PRODUCT.EPP.SETTINGS.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" type="button" (click)="save()">
    <fa-icon [icon]="['far', 'check']"></fa-icon>
    {{ 'PRODUCT.EPP.SETTINGS.SAVE' | translate }}
  </button>
</div>
